import { FileReader, FileWriter } from "@/platform";
import ModuleId from "./DataStructModuleId";

class ProjectConstant{

    public mid = ModuleId.projectConstant
    public hardMode: boolean = false; //是否开启了困难模式
    public isNewCheck: boolean = true; //工程新建时，此值为true （用于兼容版本，之前版本打开值为false 用做初始判断
    public dataVersion: number = 107 //工具的版本号
    public coverImage: string = ""; //封面图片
    public gameVersion: number = 0; //游戏版本号 o 
    public textIndex: number = 0; // 0 
    public bubbleIndex: number = 0; //气泡标识
    public endId: number = 0; //结局ID
    public userFowers: number = 0; //作者设置最终的鲜花数
    public autoCheckFlowers: number = -1; //自动检测使用鲜花数
    public userVit: number = 0;
    public autoCheckVit: number = -1; //自动检测使用鲜花数   project_bin_no
    public isMallNew: boolean = true;
    public signEncode: string = ""; //活动报名码
    public projectPath = ""

    readBin(reader: FileReader): void {
        this.hardMode = reader.readBool()
        this.isNewCheck = reader.readBool()
        this.dataVersion = reader.readInt()
        this.coverImage = reader.readString()
        this.gameVersion = reader.readInt()
        this.textIndex = reader.readInt()
        this.bubbleIndex = reader.readInt()
        this.endId = reader.readInt()
        this.userFowers = reader.readInt()
        this.autoCheckFlowers = reader.readInt()
        this.userVit = reader.readInt()
        this.autoCheckVit = reader.readInt()
        this.isMallNew = reader.readBool()
        this.signEncode = reader.readString()
    }
    
    writeBin(writer: FileWriter): void {
        writer.writeBool(this.hardMode)
        writer.writeBool(this.isNewCheck)
        writer.writeInt(this.dataVersion)
        writer.writeString(this.coverImage)
        writer.writeInt(this.gameVersion)
        writer.writeInt(this.textIndex)
        writer.writeInt(this.bubbleIndex)
        writer.writeInt(this.endId)
        writer.writeInt(this.userFowers)
        writer.writeInt(this.autoCheckFlowers)
        writer.writeInt(this.userVit)
        writer.writeInt(this.autoCheckVit)
        writer.writeBool(this.isMallNew)
        writer.writeString(this.signEncode)
    }
}
export default ProjectConstant